// A TRADUÇÃO ENTRE O ENDEREÇO DO ROTEADOR E O DA BARRA (06/10/2026).
// Funções puras — quem guarda a conta e mexe na história é `historiaLimpa.js`.
import { REGRAS, PALAVRAS } from './tabela';

const PREFIXO_INTERNO = /^\/app\/accounts\/(\d+)(?:\/(.*))?$/;

const separar = endereco => {
  const indiceHash = endereco.indexOf('#');
  const semHash = indiceHash >= 0 ? endereco.slice(0, indiceHash) : endereco;
  const hash = indiceHash >= 0 ? endereco.slice(indiceHash) : '';
  const indiceQuery = semHash.indexOf('?');
  return {
    caminho: indiceQuery >= 0 ? semHash.slice(0, indiceQuery) : semHash,
    resto: (indiceQuery >= 0 ? semHash.slice(indiceQuery) : '') + hash,
  };
};

const segmentos = texto => texto.split('/').filter(Boolean).length;

// Mais específica primeiro: `processos/dashboard` antes de `processos`.
const ordenadas = lado =>
  [...REGRAS].sort((a, b) => segmentos(b[lado]) - segmentos(a[lado]));
const PARA_FORA = ordenadas('interno');
const PARA_DENTRO = ordenadas('externo');

const casar = (regra, lado, alvo) => {
  const base = regra[lado];
  const exato = alvo === base;
  const abaixo = alvo.startsWith(`${base}/`);
  if (regra.tipo === 'exato') return exato ? '' : null;
  if (regra.tipo === 'filhos') return abaixo ? alvo.slice(base.length) : null;
  if (exato) return '';
  return abaixo ? alvo.slice(base.length) : null;
};

// As palavras de dentro do caminho, de mão dupla (`PALAVRAS`). Um pedaço que
// já é uma palavra TRADUZIDA sem ser tradução (uma etiqueta chamada
// "agentes", por exemplo) ganha a marca `~` na ida e a perde na volta — sem
// ela, a volta trocaria "agentes" por "agents".
const FORA = new Map(Object.entries(PALAVRAS));
const DENTRO = new Map(
  Object.entries(PALAVRAS).map(([de, para]) => [para, de])
);
const MARCA = '~';

const palavraParaFora = pedaco => {
  if (!pedaco) return pedaco;
  if (FORA.has(pedaco)) return FORA.get(pedaco);
  if (DENTRO.has(pedaco) || pedaco.startsWith(MARCA))
    return `${MARCA}${pedaco}`;
  return pedaco;
};

const palavraParaDentro = pedaco => {
  if (!pedaco) return pedaco;
  if (pedaco.startsWith(MARCA)) return pedaco.slice(MARCA.length);
  return DENTRO.get(pedaco) ?? pedaco;
};

const traduzirResto = (resto, para) =>
  resto
    .split('/')
    .map(para === 'externo' ? palavraParaFora : palavraParaDentro)
    .join('/');

const trocar = (lista, de, para, alvo) => {
  const limpo = alvo.replace(/\/+$/, '');
  const regra = lista.find(r => casar(r, de, limpo) !== null);
  if (!regra) return null;
  return `${regra[para]}${traduzirResto(casar(regra, de, limpo), para)}`;
};

// `/app/accounts/1/processos/27?aba=ged` → { conta: '1', caminho: 'processos/27' }
export const lerInterno = endereco => {
  const { caminho } = separar(endereco);
  const casou = PREFIXO_INTERNO.exec(caminho.replace(/\/+$/, ''));
  return casou ? { conta: casou[1], caminho: casou[2] || '' } : null;
};

// Interno → o que a barra mostra. Só traduz a conta principal; o resto (outra
// conta, login, rotas sem tradução) fica como está.
export const paraExterno = (endereco, contaPrincipal) => {
  const { caminho, resto } = separar(endereco);
  const lido = lerInterno(caminho);
  if (!lido || !contaPrincipal || lido.conta !== String(contaPrincipal)) {
    return endereco;
  }
  const traduzido = trocar(PARA_FORA, 'interno', 'externo', lido.caminho);
  return traduzido === null ? endereco : `/${traduzido}${resto}`;
};

// O que a barra mostra → interno. Endereço antigo passa direto. Sem conta
// conhecida, vai a conta "0" — o guarda do roteador troca pela da pessoa.
export const paraInterno = (endereco, contaPrincipal) => {
  const { caminho, resto } = separar(endereco);
  if (caminho.startsWith('/app/') || caminho === '/app') return endereco;
  const traduzido = trocar(
    PARA_DENTRO,
    'externo',
    'interno',
    caminho.replace(/^\/+/, '')
  );
  if (traduzido === null) return endereco;
  const conta = contaPrincipal ? String(contaPrincipal) : '0';
  return `/app/accounts/${conta}/${traduzido}${resto}`;
};

// Para quem decide "é um link do app?" (alertas, notificações).
export const ehEnderecoDoApp = caminho =>
  caminho.startsWith('/app/') ||
  trocar(PARA_DENTRO, 'externo', 'interno', caminho.replace(/^\/+/, '')) !==
    null;
